// extracted by mini-css-extract-plugin
module.exports = {"productImage":"ProductsSlider_productImage__3sg7l","swiperContainer":"ProductsSlider_swiperContainer__2bawC"};